import './SignUpThankYouAlreadyDone.css';

export const SignUpThankYouAlreadyDone = () => {
  return (
    <div className="thankyouDiv">
      <div className="thankyouMessage">
        We already have your information on file! If you need to change anything, text back these helpful shortcuts to our Fellow Drops phone number to update your profile.
      </div>
    </div>
  );
}

